import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Row, Card, Col, Button, Modal, Container } from "react-bootstrap";
import { useAuth } from "../../../../context/AuthContext";
import { db, storage } from "../../../../firebase";
import { getBytes, ref as storageRef } from "firebase/storage";
import {
  setDoc,
  getDoc,
  updateDoc,
  doc,
  collection,
  getDocs,
  collectionGroup,
  where,
  query,
  orderBy,
  Timestamp,
} from "firebase/firestore";
import {
  setEvent,
  eventTmp,
  paymentPrivilages,
  orderList,
  colorList,
  statusList,
  typeList,
  PatientLinkInfo,
  PatientDropDownForm,
  PatientTextInfo,
} from "../../Booking/BookingUtils";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import axios from "axios";
// import HtmlModule from "docxtemplater-html-module";
import { TabStopType, VerticalAlign, Section } from "docx";
import * as XLSX from "xlsx";
// import logo from "./your-logo.png"; // 🖼️ Replace with your local logo
import ImageModule from "docxtemplater-image-module-free";
import { base64DataURLToArrayBuffer } from "docxtemplater-image-module-free"; // helper for converting image
import { generateAnnualMaskMedicalCertBlob } from "./annualMaskMedicalCert";
import { getCHGMedicalCertTemplate, getCHGStudyDates, appendCHGStudyHours } from "./medicalCertificateTemplateUtils";
import { getLPHWorkLeaveTemplatePath, getLPHCPAPTemplatePath } from "./lphMedicalCertificateTemplates";

import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableCell,
  TableRow,
  WidthType,
  AlignmentType,
  BorderStyle,
  ImageRun,
} from "docx";
import JSZip from "jszip";

import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../../components/toast/SetToast";
import moneyBag from "../../../../images/money-bag.png";
import chg3 from "../../../../images/Logo/chg3.png"; // 🖼️ Replace with your local image
import chg9 from "../../../../images/Logo/chg9.png"; // 🖼️ Replace with your local image
import chg11 from "../../../../images/Logo/chg11.png"; // 🖼️ Replace with your local image
import chg304 from "../../../../images/Logo/chg304.png"; // 🖼️ Replace with your local image
import chgry from "../../../../images/Logo/chgry.png"; // 🖼️ Replace with your local image
import century from "../../../../images/Logo/century.jpeg"; // 🖼️ Replace with your local image
import { el } from "date-fns/locale";

// import logo from "../../../../assets/images/logo.png"; // 🖼️ Replace with your local logo

const MEDICAL_CERT_TEMPLATE_PATH = "templates/medical_cert";

const getMedicalCertTemplateBytes = (fileName) =>
  getBytes(storageRef(storage, `${MEDICAL_CERT_TEMPLATE_PATH}/${fileName}`));

const MedicalCert = () => {
  const [patients, setPatients] = useState([]);
  const [manualHN, setManualHN] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const exportInProgress = useRef(false);
  const [formType, setFormType] = useState("");
  const [language, setLanguage] = useState("th"); // default TH

  const handleFileUpload = async (e, formTypeText) => {
    const file = e.target.files[0];
    if (!file) return;
    setFormType(formTypeText);

    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    // 1. Extract and normalize HN list
    const hnValues = jsonData
      .map((row) => row.HN.toString().trim() || "")
      .filter(Boolean);

    // 2. Define helper to extract and pad arrays
    const extractAndPad = (field) => {
      console.log(`Extracting field: ${field}`);
      const values = jsonData.map((row) => {
        const value = row[field];
        return value !== undefined && value !== null ? value.toString() : "";
      });

      while (values.length < hnValues.length) {
        values.push(""); // pad with empty string
      }

      return values;
    };

    // 3. Extract all fields
    const doctorValues = extractAndPad("DOCTOR");
    const ahiValues = extractAndPad("AHI");
    const spo2Values = extractAndPad("MIN_SPO2");
    const pressureValues = extractAndPad("PRESSURE"); // same field as spo2

    // 4. Collect patientsData
    const patientsData = [];
    for (let i = 0; i < hnValues.length; i++) {
      const hn = hnValues[i];
      const doctor = doctorValues[i];
      const ahi = ahiValues[i];
      const min_spo2 = spo2Values[i];
      const pressure = pressureValues[i];

      const patientQuery = query(
        collection(db, "patients"),
        where("hn", "==", hn),
      );
      const patientSnapshot = await getDocs(patientQuery);

      for (const doc of patientSnapshot.docs) {
        const patient = {
          id: doc.id,
          ...doc.data(),
          doctor,
          ahi,
          min_spo2,
          pressure,
        };

        const bookingQuery = query(
          collectionGroup(db, "bookings"),
          where("extendedProps.hn", "==", hn),
        );
        const bookingSnapshot = await getDocs(bookingQuery);

        let latestSleepStudyDate = null;
        let ahiStudy = null;
        let doctorStudy = null;
        let orderStudy = null;
        bookingSnapshot.forEach((bookingDoc) => {
          const data = bookingDoc.data().extendedProps;
          const dateStr = data.latestSleepStudyDate;
          if (
            dateStr &&
            (!latestSleepStudyDate || dateStr > latestSleepStudyDate)
          ) {
            latestSleepStudyDate = dateStr;
            ahiStudy = data.ahi;
            doctorStudy = data.doctor;
            orderStudy = data.order;
          }
        });

        patient.latestSleepStudyDate = latestSleepStudyDate;
        if (patient.ahi == "") {
          patient.ahi = ahiStudy; // Default to 0 if AHI is empty
        }
        if (patient.doctor == "") {
          patient.doctor = doctorStudy; // Default to empty if doctor is empty
        }
        patient.order = orderStudy;
        patientsData.push(patient);
      }
    }

    setPatients(patientsData);
    console.log("Patients:", patientsData);
  };

  const loadManualPatient = async (hn) => {
    const hnClean = hn.trim();
    if (!hnClean) throw new Error("Enter an HN before exporting.");

    const patientQuery = query(
      collection(db, "patients"),
      where("hn", "==", hnClean),
    );
    const patientSnapshot = await getDocs(patientQuery);

    let patientsData;

    for (const doc of patientSnapshot.docs) {
      const patient = {
        id: doc.id,
        ...doc.data(),
        doctor: "", // Default
        ahi: "", // Default
        min_spo2: "", // Default
        pressure: "", // Default
      };

      const bookingQuery = query(
        collectionGroup(db, "bookings"),
        where("extendedProps.hn", "==", hnClean),
      );
      const bookingSnapshot = await getDocs(bookingQuery);

      let latestSleepStudyDate = null;
      let ahiStudy = null;
      let doctorStudy = null;
      let orderStudy = null;
      bookingSnapshot.forEach((bookingDoc) => {
        const data = bookingDoc.data().extendedProps;
        const dateStr = data.latestSleepStudyDate;
        if (
          dateStr &&
          (!latestSleepStudyDate || dateStr > latestSleepStudyDate)
        ) {
          latestSleepStudyDate = dateStr;
          ahiStudy = data.ahi;
          doctorStudy = data.doctor;
          orderStudy = data.order;
        }
      });

      patient.latestSleepStudyDate = latestSleepStudyDate;
      if (patient.ahi === "") {
        patient.ahi = ahiStudy;
      }
      if (patient.doctor === "") {
        patient.doctor = doctorStudy;
      }
      patient.order = orderStudy;

      patientsData = patient;
    }

    if (!patientsData) throw new Error(`Patient not found for ${hnClean}. Check the HN and try again.`);
    return patientsData;
  };

  const calculateAge = (dobStr) => {
    if (!dobStr) return "-";
    const today = new Date();
    const dob = new Date(dobStr);
    if (isNaN(dob)) return "-";

    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return `${age}`;
  };

  const handleExport = async (patient) => {
    try {
      const response = await axios.get("/templates/CHG-ใบรับรองแพทย์.docx", {
        responseType: "arraybuffer",
      });

      const zip = new PizZip(response.data);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });

      // send plain text (no HTML)
      // const filledData = {
      //   fullname: `${patient.firstnameTh} ${patient.lastnameTh}`,
      //   hnRef: patient.refHn,
      //   dob: patient.dateOfBirth || "-",
      //   age: calculateAge(patient.dateOfBirth),
      //   gender: patient.gender || "-",
      //   latestSleepStudy: formatThaiDate(patient.latestSleepStudyDate),
      //   latestSleepStudyNotice: `รับการตรวจการนอนหลับจริงในคืนวันที่ ${formatThaiDate(
      //     patient.latestSleepStudyDate
      //   )}`,
      // };

      // doc.setData(filledData);
      doc.render();

      const out = doc.getZip().generate({ type: "blob" });
      saveAs(
        out,
        `MedicalCertificate ${patient.firstnameTh} ${patient.lastnameTh}.docx`,
      );
    } catch (err) {
      console.error("Export failed:", err);
    }
  };

  const formatThaiDate = (dateStr) => {
    const monthsThai = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ];
    if (!dateStr) return "วันที่ - - พ.ศ. -";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "วันที่ - - พ.ศ. -";
    const day = date.getDate();
    const month = monthsThai[date.getMonth()];
    const year = date.getFullYear() + 543;
    return `วันที่ ${day} ${month} พ.ศ. ${year}`;
  };

  // const handleExportAll = async () => {
  //   for (const patient of patients) {
  //     await generateDocx(patient); // wait for each export before continuing
  //   }
  // };

  // const generateDocxBlob = async (patient, formatThaiDate, calculateAge) => {
  //   const underlineText = (label, value) =>
  //     new Paragraph({
  //       children: [
  //         new TextRun(label),
  //         new TextRun({ text: value || "-", underline: {} }),
  //       ],
  //     });

  //   const doc = new Document({
  //     sections: [
  //       {
  //         children: [
  //           underlineText(
  //             "ชื่อ – นามสกุล ",
  //             `${patient.firstnameTh} ${patient.lastnameTh}`
  //           ),
  //           underlineText("HN ", patient.refHn),
  //           new Paragraph({ text: "" }),
  //           underlineText("วันเกิด ", patient.dateOfBirth),
  //           underlineText("อายุ ", `${calculateAge(patient.dateOfBirth)} ปี`),
  //           underlineText("เพศ ", patient.gender),
  //           new Paragraph({ text: "" }),

  //           new Paragraph({
  //             children: [new TextRun({ text: "ใบรับรองแพทย์", bold: true })],
  //           }),

  //           new Paragraph({ text: "" }),

  //           underlineText("", formatThaiDate(patient.latestSleepStudyDate)),

  //           new Paragraph({
  //             children: [
  //               new TextRun("ได้รับการตรวจโดย "),
  //               new TextRun({
  //                 text: "แพทย์หญิง จตุพร วันไชยธนวงศ์ แพทย์แผนปัจจุบันชั้นหนึ่งสาขาเวชกรรม",
  //               }),
  //             ],
  //           }),

  //           new Paragraph({
  //             children: [
  //               new TextRun("ใบอนุญาตประกอบวิชาชีพเวชกรรมเลขที่ "),
  //               new TextRun("46338"),
  //             ],
  //           }),

  //           new Paragraph({ text: "" }),

  //           underlineText(
  //             "เมื่อวันที่ ",
  //             formatThaiDate(patient.latestSleepStudyDate)
  //           ),

  //           new Paragraph({
  //             children: [
  //               new TextRun("ได้รับการวินิจฉัยว่าเป็น "),
  //               new TextRun({
  //                 text: "สงสัยโรคหยุดหายใจขณะหลับจากการอุดกั้น",
  //               }),
  //             ],
  //           }),

  //           new Paragraph({
  //             children: [
  //               new TextRun("มีความเห็นว่า "),
  //               new TextRun({
  //                 text: "จำเป็นต้องเข้ารับการตรวจการนอนหลับ",
  //               }),
  //             ],
  //           }),

  //           new Paragraph({
  //             children: [
  //               new TextRun("หมายเหตุ "),
  //               new TextRun({
  //                 text:
  //                   "รับการตรวจการนอนหลับจริงในคืนวันที่ " +
  //                   formatThaiDate(patient.latestSleepStudyDate),
  //                 underline: {},
  //               }),
  //             ],
  //           }),

  //           new Paragraph({
  //             text: "\n\nผู้รับ ________________________     ลงชื่อ _______________________",
  //           }),
  //           new Paragraph({
  //             text: "     (________________________)           (แพทย์หญิง จตุพร วันไชยธนวงศ์)",
  //           }),
  //           new Paragraph({ text: "วันที่ ________________________" }),
  //         ],
  //       },
  //     ],
  //   });

  //   const blob = await Packer.toBlob(doc);
  //   return blob;
  // };

  const generateCHGTemplateDocxBlob = async (
    patient,
    formatThaiDate,
    calculateAge,
  ) => {
    const getCurrentDate = () => {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formatNormal = (isoDateStr) => {
      const [year, month, day] = isoDateStr.split("-");
      return `${day}/${month}/${year}`;
    };

    const getThaiDate = (date) => {
      return (
        "วันที่ " +
        date.toLocaleDateString("th-TH", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      );
    };

    const customer = patient.order.split("-")[0];
    // console.log("Customer:", customer);
    let logo = century;
    const templateFileName = getCHGMedicalCertTemplate(patient.order);
    let divideWidth = 2;

    switch (customer) {
      case "CHG03":
        logo = chg3;
        divideWidth = 1;
        break;
      case "CHG11":
        logo = chg11;
        divideWidth = 1;
        break;
      case "CHG304":
        logo = chg304;
        divideWidth = 1;
        break;
      case "CHG09":
        logo = chg9;
        divideWidth = 1;
        break;
      case "CHG":
        logo = century;
        divideWidth = 2;
      default:
        logo = century;
        divideWidth = 2;
    }

    // ✅ Convert local image to base64 using <img> + canvas
    // const logoBase64 = await new Promise((resolve, reject) => {
    //   const img = new Image();
    //   img.crossOrigin = "anonymous";
    //   img.src = logo;

    //   img.onload = () => {
    //     const canvas = document.createElement("canvas");
    //     canvas.width = img.width;
    //     canvas.height = img.height;
    //     const ctx = canvas.getContext("2d");
    //     ctx.drawImage(img, 0, 0);
    //     const base64 = canvas.toDataURL("image/png");
    //     resolve(base64);
    //   };

    //   img.onerror = reject;
    // });

    try {
      const docxBuffer = await getMedicalCertTemplateBytes(templateFileName);

      const imageModule = new ImageModule({
        centered: false,
        getImage: (tagValue) => {
          return base64DataURLToArrayBuffer(tagValue);
        },
        getSize: () => [250 / divideWidth, 100],
      });

      const zip = new PizZip(docxBuffer);
      const doc = new Docxtemplater(zip, {
        modules: [imageModule],
        paragraphLoop: true,
        linebreaks: true,
        delimiters: { start: "<", end: ">" },
      });

      const studyDate = new Date(patient.latestSleepStudyDate);

      const patientHN = patient.refHn || patient.hn || "";

      doc.setData({
        PATIENT_NAME: `${patient.firstnameTh.trim()} ${patient.lastnameTh.trim()}`,
        HN_REF: patientHN,
        DOB: formatNormal(patient.dateOfBirth),
        AGE: calculateAge(patient.dateOfBirth),
        GENDER: patient.gender,
        CURRENT_DATE_TH: getCHGStudyDates(patient.latestSleepStudyDate).studyDateThai,
        STUDY_DATE_TH: getThaiDate(studyDate),
      });

      doc.render();

      const blob = appendCHGStudyHours(doc.getZip(), patient.latestSleepStudyDate).generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      return blob;
    } catch (error) {
      throw error;
    }
  };

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // base64 string
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const generateCHGDocxBlob = async (patient, formatThaiDate, calculateAge) => {
    const getCurrentDate = () => {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months start from 0
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formatNormal = (isoDateStr) => {
      const [year, month, day] = isoDateStr.split("-");
      return `${day}/${month}/${year}`;
    };

    var logo = century;
    var customer = patient.order.split("-")[0];
    var divideWidth = 2;

    if (customer == "CHG") {
      logo = century;
      divideWidth = 2;
    } else if (customer == "CHG03") {
      logo = chg3;
      divideWidth = 1;
    } else if (customer == "CHG11") {
      logo = chg11;
      divideWidth = 1;
    } else if (customer == "CHG304") {
      logo = chg304;
      divideWidth = 1;
    } else if (customer == "CHG09") {
      logo = chg9;
      divideWidth = 1;
    } else {
      logo = century;
      divideWidth = 2;
    }

    const TAB_POSITION = 2000; // twips (~2.8 inches) — adjust as needed

    const underline = (text) =>
      new TextRun({ text, underline: {}, font: "Angsana New" });

    const spacedParagraph = (options) =>
      new Paragraph({
        spacing: { line: 480 },
        ...options,
      });

    const spacedHeaderParagraph = (options) =>
      new Paragraph({
        spacing: { line: 360 },
        ...options,
      });

    const textRun = (text, options = {}) =>
      new TextRun({
        text,
        font: "Angsana New",
        ...options,
      });

    const logoData = await fetch(logo).then((r) => r.arrayBuffer());

    const patientInfoTable = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              margins: { bottom: 100, right: 100 },
              children: [
                new Paragraph({
                  children: [
                    new ImageRun({
                      data: logoData,
                      transformation: { width: 250 / divideWidth, height: 100 },
                    }),
                  ],
                }),
              ],
              borders: {
                top: { style: BorderStyle.NIL },
                bottom: { style: BorderStyle.NIL },
                left: { style: BorderStyle.NIL },
                right: { style: BorderStyle.NIL },
                insideHorizontal: { style: BorderStyle.NIL },
                insideVertical: { style: BorderStyle.NIL }, // 👈 disables that inner line!
              },

              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              margins: { bottom: 100, right: 100, top: 0 },

              children: [
                spacedHeaderParagraph({
                  alignment: AlignmentType.RIGHT, // 👈 move text to the right
                  children: [
                    new textRun("ชื่อ-นามสกุล "),
                    new textRun(
                      `${patient.firstnameTh.trim()} ${patient.lastnameTh.trim()}`,
                    ),
                    new textRun(" HN "),
                    new textRun(patient.refHn),
                  ],
                }),
                spacedHeaderParagraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new textRun("วันเกิด "),
                    new textRun(formatNormal(patient.dateOfBirth)),
                    new textRun(" อายุ "),
                    new textRun(`${calculateAge(patient.dateOfBirth)} ปี`),
                    new textRun(" เพศ "),
                    new textRun(patient.gender),
                  ],
                }),
              ],
              borders: {
                top: { style: BorderStyle.NIL },
                bottom: { style: BorderStyle.NIL },
                left: { style: BorderStyle.NIL },
                right: { style: BorderStyle.NIL },
                insideHorizontal: { style: BorderStyle.NIL },
                insideVertical: { style: BorderStyle.NIL }, // 👈 disables that inner line!
              },

              verticalAlign: VerticalAlign.CENTER,
            }),
          ],
        }),
      ],
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: {
        top: { style: BorderStyle.NIL },
        bottom: { style: BorderStyle.NIL },
        left: { style: BorderStyle.NIL },
        right: { style: BorderStyle.NIL },
        insideHorizontal: { style: BorderStyle.NIL },
        insideVertical: { style: BorderStyle.NIL }, // 👈 disables that inner line!
      },
    });

    const boxTable = new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: {
        top: { style: BorderStyle.SINGLE, size: 5, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 5, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 5, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 5, color: "000000" },
      },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              margins: {
                top: 200,
                bottom: 200,
                left: 360,
                right: 360,
              },
              children: [
                spacedParagraph({
                  alignment: AlignmentType.CENTER,
                  children: [
                    textRun("ใบรับรองแพทย์", { bold: true, size: 24 }),
                  ],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),

                spacedParagraph({
                  alignment: AlignmentType.RIGHT,
                  children: [new textRun(formatThaiDate(patient.latestSleepStudyDate))],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),

                spacedParagraph({
                  children: [
                    new textRun("ได้รับการตรวจโดย "),
                    underline("แพทย์หญิง จตุพร วันไชยธนวงศ์"),
                    new textRun(" แพทย์แผนปัจจุบันชั้นหนึ่งสาขาเวชกรรม"),
                  ],
                }),
                spacedParagraph({
                  children: [
                    new textRun("ใบอนุญาตประกอบวิชาชีพเวชกรรมเลขที่ "),
                    underline("46338"),
                  ],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),
                spacedParagraph({
                  children: [
                    new textRun("เมื่อ "),
                    underline(formatThaiDate(patient.latestSleepStudyDate)),
                  ],
                }),
                spacedParagraph({
                  tabStops: [
                    {
                      type: TabStopType.LEFT,
                      position: TAB_POSITION,
                    },
                  ],
                  children: [
                    new textRun("ได้รับการวินิจฉัยว่าเป็น\t"),
                    underline("สงสัยโรคหยุดหายใจขณะหลับจากการอุดกั้น"),
                  ],
                }),
                spacedParagraph({
                  tabStops: [
                    {
                      type: TabStopType.LEFT,
                      position: TAB_POSITION,
                    },
                  ],
                  children: [
                    new textRun("มีความเห็นว่า\t"),
                    underline("จำเป็นต้องเข้ารับการตรวจการนอนหลับ"),
                  ],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),
                spacedParagraph({
                  tabStops: [
                    {
                      type: TabStopType.LEFT,
                      position: TAB_POSITION,
                    },
                  ],
                  children: [
                    new textRun("หมายเหตุ\t"),
                    underline(
                      `รับการตรวจการนอนหลับจริงในคืน${formatThaiDate(
                        patient.latestSleepStudyDate,
                      )} ${getCHGStudyDates(patient.latestSleepStudyDate).startTimeText}`,
                    ),
                    textRun("\t", { break: 1 }),
                    underline(getCHGStudyDates(patient.latestSleepStudyDate).endTimeText),
                  ],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),
                spacedParagraph({
                  children: [new textRun("")],
                }),
                spacedParagraph({
                  children: [
                    new textRun(
                      "ผู้รับ  _____________________________\tลงชื่อ _____________________________",
                    ),
                  ],
                  tabStops: [{ type: TabStopType.RIGHT, position: 8200 }],
                }),
                spacedParagraph({
                  children: [
                    new textRun(
                      "      (____________________________)\t(แพทย์หญิง จตุพร วันไชยธนวงศ์)",
                    ),
                  ],
                  tabStops: [{ type: TabStopType.RIGHT, position: 8200 }],
                }),
                spacedParagraph({
                  children: [
                    new textRun("วันที่  _____________________________"),
                  ],
                  tabStops: [{ type: TabStopType.RIGHT, position: 8200 }],
                }),

                spacedParagraph({
                  children: [new textRun("")],
                }),
              ],
            }),
          ],
        }),
      ],
    });

    const doc = new Document({
      sections: [
        {
          children: [
            patientInfoTable,
            new Paragraph({ text: "" }),
            boxTable,

            // spacedParagraph({
            //   children: [
            //     new textRun(
            //       "ลงชื่อ _____________________________\tลงชื่อ _____________________________"
            //     ),
            //   ],
            //   tabStops: [{ type: TabStopType.RIGHT, position: 8900 }],
            // }),
            // spacedParagraph({
            //   children: [
            //     new textRun(
            //       "ผู้รับ  _____________________________\t(แพทย์หญิง จตุพร วันไชยธนวงศ์)"
            //     ),
            //   ],
            //   tabStops: [{ type: TabStopType.RIGHT, position: 8900 }],
            // }),
            // spacedParagraph({
            //   children: [
            //     new textRun(
            //       "วันที่  _____________________________\tวันที่  _____________________________"
            //     ),
            //   ],
            //   tabStops: [{ type: TabStopType.RIGHT, position: 8900 }],
            // }),
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    return blob;
  };

  // const generateLPHWorkLeaveDocxBlob = async (patient, doctor, language) => {
  //   const getThaiDate = (date) => {
  //     return (
  //       "วันที่ " +
  //       date.toLocaleDateString("th-TH", {
  //         day: "numeric",
  //         month: "long",
  //         year: "numeric",
  //       })
  //     );
  //   };
  //   const doctor_SPL =
  //     "https://firebasestorage.googleapis.com/v0/b/braindynamics-197809/o/templates%2Fmedical_cert%2FLPH_WorkLeave_SPL.docx?alt=media&token=dbaf11f7-d715-4fc8-92c6-88162a070daa";
  //   const doctor_JDS =
  //     "https://firebasestorage.googleapis.com/v0/b/braindynamics-197809/o/templates%2Fmedical_cert%2FLPH_WorkLeave_JDS.docx?alt=media&token=be499434-0b36-4a93-bce6-89ad05b70ef5";
  //   const doctor_VCR = ""

  //   const doctor_SPL_EN = ""
  //   const doctor_JDS_EN = ""
  //   const doctor_VCR_EN = ""

  //   try {
  //     const response = await fetch(
  //       doctor.trim() == "S.Jindapa" ? doctor_JDS : doctor_SPL,
  //     );
  //     const content = await response.arrayBuffer();

  //     const zip = new PizZip(content);

  //     const doc = new Docxtemplater(zip, {
  //       paragraphLoop: true,
  //       linebreaks: true,
  //       delimiters: { start: "<", end: ">" }, // Support <PLACEHOLDER>
  //     });

  //     const currentThaiDate = getThaiDate(new Date());
  //     const studyDate = new Date(patient.latestSleepStudyDate);

  //     const data = {
  //       CURRENT_DATE_TH: currentThaiDate,
  //       PATIENT_NAME: `${patient.firstnameTh.trim()} ${patient.lastnameTh.trim()}`,
  //       STUDY_DATE_TH: getThaiDate(studyDate),
  //     };

  //     doc.setData(data);
  //     doc.render();

  //     const blob = doc.getZip().generate({
  //       type: "blob",
  //       mimeType:
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     });

  //     return blob;
  //   } catch (error) {
  //     console.error("Error generating DOCX:", error);
  //     return null;
  //   }
  // };

  const generateLPHWorkLeaveDocxBlob = async (
    patient,
    doctor,
    language = "th",
  ) => {
    const formatDate = (date, lang) => {
      const d = date instanceof Date ? date : new Date(date);

      if (lang === "th") {
        return (
          "วันที่ " +
          d.toLocaleDateString("th-TH", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
        );
      }

      // EN (choose en-GB for "20 January 2026" style)
      return (
        "Date: " +
        d.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      );
    };

    const getPatientName = (p, lang) => {
      const safe = (v) => (v || "").toString().trim();

      if (lang === "en") {
        const title = safe(p.titleEn) || safe(p.titleTH) || safe(p.titleTh);
        const fn =
          safe(p.firstnameEn) || safe(p.firstnameTH) || safe(p.firstnameTh);
        const ln =
          safe(p.lastnameEn) || safe(p.lastnameTH) || safe(p.lastnameTh);
        return [title, fn, ln].filter(Boolean).join(" ");
      }

      const title = safe(p.titleTh) || safe(p.titleTH) || safe(p.titleEn);
      const fn =
        safe(p.firstnameTh) || safe(p.firstnameTH) || safe(p.firstnameEn);
      const ln = safe(p.lastnameTh) || safe(p.lastnameTH) || safe(p.lastnameEn);
      return [title, fn, ln].filter(Boolean).join(" ");
    };

    try {
      const lang = (language || "th").toLowerCase();
      const content = await getBytes(storageRef(storage, getLPHWorkLeaveTemplatePath(doctor)));

      const zip = new PizZip(content);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
        delimiters: { start: "<", end: ">" },
      });

      const studyDate = new Date(patient.latestSleepStudyDate);

      // ✅ Use SAME placeholder keys in BOTH TH/EN templates
      const data = {
        CURRENT_DATE_TH: formatDate(new Date(), lang),
        PATIENT_NAME: getPatientName(patient, lang),
        STUDY_DATE_TH: formatDate(studyDate, lang),
        // add more fields as needed
      };

      doc.setData(data);
      doc.render();

      return doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
    } catch (error) {
      throw error;
    }
  };

  const generateLPHCPAPDocxBlob = async (
    patient,
    doctor,
    ahi,
    minSpo2Tib,
    pressure,
    language,
  ) => {
    const formatDate = (date, lang) => {
      const d = date instanceof Date ? date : new Date(date);

      if (lang === "th") {
        return (
          "วันที่ " +
          d.toLocaleDateString("th-TH", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })
        );
      }

      // EN (choose en-GB for "20 January 2026" style)
      return (
        "Date: " +
        d.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      );
    };

    const getPatientName = (p, lang) => {
      const safe = (v) => (v || "").toString().trim();

      if (lang === "en") {
        const title = safe(p.titleEn) || safe(p.titleTH) || safe(p.titleTh);
        const fn =
          safe(p.firstnameEn) || safe(p.firstnameTH) || safe(p.firstnameTh);
        const ln =
          safe(p.lastnameEn) || safe(p.lastnameTH) || safe(p.lastnameTh);
        return [title, fn, ln].filter(Boolean).join(" ");
      }

      const title = safe(p.titleTh) || safe(p.titleTH) || safe(p.titleEn);
      const fn =
        safe(p.firstnameTh) || safe(p.firstnameTH) || safe(p.firstnameEn);
      const ln = safe(p.lastnameTh) || safe(p.lastnameTH) || safe(p.lastnameEn);
      return [title, fn, ln].filter(Boolean).join(" ");
    };

    try {
      const lang = (language || "th").toLowerCase();
      const content = await getBytes(storageRef(storage, getLPHCPAPTemplatePath(doctor, lang)));

      const zip = new PizZip(content);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
        delimiters: { start: "<", end: ">" },
      });

      const studyDate = new Date(patient.latestSleepStudyDate);

      // ✅ Use SAME placeholder keys in BOTH TH/EN templates
      const data = {
        CURRENT_DATE_TH: formatDate(new Date(), lang),
        DOCTOR_SCORED_DATE_TH: formatDate(new Date(), lang),
        PATIENT_NAME: getPatientName(patient, lang),
        STUDY_DATE_TH: formatDate(studyDate, lang),
        AHI: ahi ? ahi.toString() : patient.ahi.toString() || "0",
        MIN_SPO2: minSpo2Tib.toString(),
        PRESSURE: pressure != "" ? pressure : "5-15",
      };

      doc.setData(data);
      doc.render();

      return doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
    } catch (error) {
      console.error("Error generating DOCX:", error);
      return null;
    }
  };

  // const generateLPHCPAPDocxBlob = async (
  //   patient,
  //   doctor,
  //   ahi,
  //   minSpo2Tib,
  //   pressure,
  //   language,
  // ) => {
  //   const getThaiDate = (date) => {
  //     return (
  //       "วันที่ " +
  //       date.toLocaleDateString("th-TH", {
  //         day: "numeric",
  //         month: "long",
  //         year: "numeric",
  //       })
  //     );
  //   };
  //   var response;
  //   const doctor_SPL =
  //     "https://firebasestorage.googleapis.com/v0/b/braindynamics-197809/o/templates%2Fmedical_cert%2FLPH_medical_cert_SPL.docx?alt=media&token=7b64f87c-55b8-4ba8-9ea7-1c09aef4bd8d";
  //   const doctor_JDS =
  //     "https://firebasestorage.googleapis.com/v0/b/braindynamics-197809/o/templates%2Fmedical_cert%2FLPH_medical_cert_JDS.docx?alt=media&token=95929d7c-348e-4fc9-a921-57dc8b3cf5ae";

  //   try {
  //     if (doctor) {
  //       response = await fetch(
  //         doctor.trim() == "S.Jindapa" ? doctor_JDS : doctor_SPL,
  //       );
  //     } else {
  //       response = await fetch(
  //         patient.doctor.trim() == "S.Jindapa" ? doctor_JDS : doctor_SPL,
  //       );
  //     }
  //     const content = await response.arrayBuffer();

  //     const zip = new PizZip(content);

  //     const doc = new Docxtemplater(zip, {
  //       paragraphLoop: true,
  //       linebreaks: true,
  //       delimiters: { start: "<", end: ">" }, // Support <PLACEHOLDER>
  //     });

  //     const currentThaiDate = getThaiDate(new Date());
  //     const studyDate = new Date(patient.latestSleepStudyDate);

  //     const data = {
  //       DOCTOR_SCORED_DATE_TH: currentThaiDate,
  //       PATIENT_NAME: `${patient.firstnameTh.trim()} ${patient.lastnameTh.trim()}`,
  //       STUDY_DATE_TH: getThaiDate(studyDate),
  //       AHI: ahi ? ahi.toString() : patient.ahi.toString() || "0",
  //       MIN_SPO2: minSpo2Tib.toString(),
  //       PRESSURE: pressure != "" ? pressure : "5-15",
  //     };

  //     doc.setData(data);
  //     doc.render();

  //     const blob = doc.getZip().generate({
  //       type: "blob",
  //       mimeType:
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     });

  //     return blob;
  //   } catch (error) {
  //     console.error("Error generating DOCX:", error);
  //     return null;
  //   }
  // };

  const generateLPHMaskDocxBlob = async (
    patient,
    doctor,
    ahi,
    minSpo2Tib,
    pressure,
  ) =>
    generateAnnualMaskMedicalCertBlob({
      patient,
      doctor,
      ahi,
      minSpo2: minSpo2Tib,
      pressure,
      latestSleepStudyDate: patient.latestSleepStudyDate,
    });

  const handleExportAll = async (type) => {
    const zip = new JSZip();

    for (const patient of patients) {
      let blob;
      try {
        if (patient.nodeRef == "Chularat Hospital Group") {
          if (type === "WorkLeave") {
            blob = await generateCHGDocxBlob(
              patient,
              formatThaiDate,
              calculateAge,
            );
          } else if (type === "CPAPPurchase") {
          }
        } else if (patient.nodeRef == "Ladprao Hospital") {
          if (type === "WorkLeave") {
            blob = await generateLPHWorkLeaveDocxBlob(
              patient,
              patient.doctor,
              language,
            );
          } else if (type === "CPAPPurchase") {
            blob = await generateLPHCPAPDocxBlob(
              patient,
              patient.doctor,
              patient.ahi,
              patient.min_spo2,
              patient.pressure,
            );
          } else if (type == "AnnualPurchase") {
            blob = await generateLPHMaskDocxBlob(
              patient,
              patient.doctor,
              patient.ahi,
              patient.min_spo2,
              patient.pressure,
            );
          }
        }
        const safeName =
          `${patient.firstnameTh.trim()} ${patient.lastnameTh.trim()}`.replace(
            /[^a-zA-Z0-9-_ก-๙]/g,
            "_",
          );
        const filename = `${safeName}.docx`;

        if (blob) zip.file(filename, blob);
      } catch (err) {
        console.error("❌ Failed to generate docx for:", patient, err);
      }
    }

    try {
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${type}-MedicalCerts.zip`);
    } catch (err) {
      console.error("❌ Failed to generate ZIP:", err);
    }
  };

  const handleSingleExport = async (type) => {
    if (exportInProgress.current) return;
    exportInProgress.current = true;
    setIsExporting(true);
    let blob;

    try {
      const patient = await loadManualPatient(manualHN);
      if (!patient.latestSleepStudyDate) {
        throw new Error("No sleep study date was found. Check the patient's booking before exporting.");
      }
      if (patient.nodeRef === "Chularat Hospital Group") {
        console.log("Generating CHG docx...");
        if (type === "WorkLeave") {
          console.log("Generating CHG Work Leave docx...");
          blob = await generateCHGTemplateDocxBlob(
            patient,
            formatThaiDate,
            calculateAge,
          );
        } else if (type === "CPAPPurchase") {
          // Add logic here if needed
        }
      } else if (patient.nodeRef === "Ladprao Hospital") {
        console.log("Generating LPH docx...");
        if (type === "WorkLeave") {
          blob = await generateLPHWorkLeaveDocxBlob(
            patient,
            patient.doctor,
            language,
          );
        } else if (type === "CPAPPurchase") {
          blob = await generateLPHCPAPDocxBlob(
            patient,
            patient.doctor,
            patient.ahi,
            patient.min_spo2,
            patient.pressure,
          );
        } else if (type === "AnnualPurchase") {
          blob = await generateLPHMaskDocxBlob(
            patient,
            patient.doctor,
            patient.ahi,
            patient.min_spo2,
            patient.pressure,
          );
        }
      } else {
        throw new Error("Medical certificate export is not available for this hospital group.");
      }

      if (!blob) throw new Error("Unable to generate the medical certificate. Please try again.");
      if (blob) {
        const safeName =
          `${patient.firstnameTh.trim()} ${patient.lastnameTh.trim()}`.replace(
            /[^a-zA-Z0-9-_ก-๙]/g,
            "_",
          );
        const filename = `${safeName}.docx`;

        saveAs(blob, filename); // ✅ download directly
      }
    } catch (err) {
      notifyError(err.message || "Unable to export the medical certificate. Please try again.");
    } finally {
      exportInProgress.current = false;
      setIsExporting(false);
    }
  };

  // const handleDownload = () => {
  //   const text = `
  //   โรงพยาบาลเจ้าพระยาอภัยภูเบศร
  //   ใบรับรองแพทย์การตรวจการนอนหลับจริง

  //   ชื่อ-สกุล: นาย อนุรักษ์ หมอสมบูรณ์
  //   เลขที่ HN: HN-67010123
  //   วันเดือนปีเกิด: 01 มกราคม 2520
  //   อายุ: 45 ปี
  //   เพศ: ชาย

  //   ผลการตรวจการนอนหลับ
  //   รับการตรวจการนอนหลับจริงในคืนวันที่ 18 กรกฎาคม พ.ศ. 2568
  // `;

  //   // Create simple Word doc manually
  //   const zip = new PizZip();
  //   zip.file(
  //     "word/document.xml",
  //     `
  //   <w:document xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main">
  //     <w:body>
  //       <w:p><w:r><w:t>${text.replace(
  //         /\n/g,
  //         "</w:t></w:r></w:p><w:p><w:r><w:t>"
  //       )}</w:t></w:r></w:p>
  //     </w:body>
  //   </w:document>
  // `
  //   );
  //   zip.file(
  //     "[Content_Types].xml",
  //     `
  //   <Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
  //     <Default Extension="xml" ContentType="application/xml"/>
  //     <Override PartName="/word/document.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/>
  //   </Types>
  // `
  //   );
  //   zip.file(
  //     "_rels/.rels",
  //     `
  //   <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  //     <Relationship Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml" Id="rId1"/>
  //   </Relationships>
  // `
  //   );

  //   const doc = new Docxtemplater(zip, {
  //     paragraphLoop: true,
  //     linebreaks: true,
  //   });

  //   const blob = doc.getZip().generate({ type: "blob" });
  //   saveAs(blob, "Medical_Certificate.docx");
  // };

  return (
    <>
      <div
        style={{
          backgroundColor: "#fff3cd",
          color: "#856404",
          padding: "1rem",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          margin: "1rem 0",
        }}
      >
        <strong>Note:</strong> Please use the correct HN format from the company
        in the template file (e.g., <code>HN-XXXXXX</code>).
        <br />
        <br />
        <strong>Instructions:</strong>
        <ol style={{ paddingLeft: "1.2rem", margin: 0 }}>
          <li>
            <strong>Medical Certificate For Sleep Study Attendance:</strong>
            <ul style={{ paddingLeft: "1.2rem", marginTop: "0.3rem" }}>
              <li>
                <strong>CHG:</strong> Only the <strong>HN</strong> field is
                required.
              </li>
              <li>
                <strong>LPH:</strong> <strong>HN</strong> and{" "}
                <strong>Doctor</strong> fields are required.
              </li>
            </ul>
          </li>

          <li style={{ marginTop: "1rem" }}>
            <strong>
              Medical Certificate for CPAP Purchase and Annual 1 Year Mask
              Purchase:
            </strong>
            <ul style={{ paddingLeft: "1.2rem", marginTop: "0.3rem" }}>
              <li>
                Supports <strong>LPH</strong> only.
              </li>
              <li>All fields must be filled in.</li>
              <li>
                <strong>Doctor options for LPH CPAP Purchase:</strong>
                <ul style={{ paddingLeft: "1.2rem", margin: "0.3rem 0" }}>
                  <li style={{ paddingLeft: "2rem" }}>S. Jindapa</li>
                  <li style={{ paddingLeft: "2rem" }}>L. Somprasong</li>
                  <li style={{ paddingLeft: "2rem" }}>C. Vatcharee</li>
                </ul>
              </li>
              <li>
                <strong>Annual 1 Year Mask Purchase:</strong> C. Vatcharee
                and S. Jindapa only.
              </li>
            </ul>
          </li>
        </ol>
        <br />
        {"Download template here → "}
        <a
          href="https://firebasestorage.googleapis.com/v0/b/sleepy-9b23f.firebasestorage.app/o/templates%2FMedicalCertTemplate.xlsx?alt=media&token=b93a8a8a-a5e9-4433-82d9-e28d5b889fc1"
          download
          style={{ textDecoration: "underline", color: "#856404" }}
        >
          Template
        </a>
      </div>

      <div className="col-lg-12 mb-5">
        <div className="row">
          <div className="col-xl-6 col-lg-6 mt-4">
            <b>Export One Medical Certificate For Sleep Study Attendance</b>
            <div className="d-flex gap-2 mb-3">
              <input
                type="text"
                placeholder="HN-XXXXXX"
                className="form-control"
                value={manualHN}
                disabled={isExporting}
                onChange={(e) => setManualHN(e.target.value)}
              />
              <button
                className="btn btn-success ml-3"
                disabled={isExporting || !manualHN.trim()}
                onClick={() => handleSingleExport("WorkLeave")}
              >
                {isExporting ? "Exporting..." : "Export"}
              </button>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 mt-4">
            <label className="form-label">Language</label>
            <select
              className="form-control"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="th">TH</option>
              <option value="en">EN</option>
            </select>
          </div>
          {/* <div className="col-xl-6 col-lg-6 mt-4">
            <b>Export One Medical Certificate for Annual Mask Purchase</b>
            <div className="d-flex gap-2 mb-3">
              <input
                type="text"
                placeholder="HN-XXXXXX"
                className="form-control"
                onChange={(e) => handleManualHNInput(e.target.value)}
              />
              <button
                className="btn btn-success ml-3"
                onClick={() => handleSingleExport("AnnualPurchase")}
              >
                Export
              </button>
            </div>
          </div> */}
        </div>
        <div className="row">
          <div className="col-xl-6 col-lg-6 mt-4">
            <b>Import Template File For Sleep Study Attendance</b>
            <input
              type="file"
              accept=".xlsx, .xls"
              className="form-control mt-2"
              onChange={(e) => handleFileUpload(e, "WorkLeave")}
            />
            {patients.length > 0 && formType == "WorkLeave" && (
              <div className="mt-3">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>HN</th>
                      <th>Fullname</th>
                      <th>Doctor</th>
                      <th>Latest Sleep Study</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patients.map((patient, index) => (
                      <tr key={patient.id || index}>
                        <td>{index + 1}</td>
                        <td>{patient.hn}</td>
                        <td>
                          {patient.firstnameTh} {patient.lastnameTh}
                        </td>
                        <td>{patient.doctor}</td>
                        <td>{patient.latestSleepStudyDate || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <button
                  className="btn btn-success"
                  onClick={() => handleExportAll("WorkLeave")}
                >
                  Export
                </button>
              </div>
            )}
          </div>
          <div className="col-xl-6 col-lg-6 mt-4">
            <b>Import Template File For Annual 1 Year Mask Purchase</b>
            <input
              type="file"
              accept=".xlsx, .xls"
              className="form-control mt-2"
              onChange={(e) => handleFileUpload(e, "AnnualPurchase")}
            />
            {patients.length > 0 && formType == "AnnualPurchase" && (
              <div className="mt-3">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>HN</th>
                      <th>Fullname</th>
                      <th>Doctor</th>
                      <th>AHI</th>
                      <th>Min SpO2</th>
                      <th>Pressure</th>
                      <th>Latest Sleep Study</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patients.map((patient, index) => (
                      <tr key={patient.id || index}>
                        <td>{index + 1}</td>
                        <td>{patient.hn}</td>
                        <td>
                          {patient.firstnameTh} {patient.lastnameTh}
                        </td>
                        <td>{patient.doctor}</td>
                        <td>{patient.ahi}</td>
                        <td>{patient.min_spo2}</td>
                        <td>{patient.pressure}</td>
                        <td>{patient.latestSleepStudyDate || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <button
                  className="btn btn-success"
                  onClick={() => handleExportAll("AnnualPurchase")}
                >
                  Export
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6 col-lg-6 mt-4">
            <b>Import Template File For CPAP Purchase</b>
            <input
              type="file"
              accept=".xlsx, .xls"
              className="form-control mt-2"
              onChange={(e) => handleFileUpload(e, "CPAPPurchase")}
            />
            {patients.length > 0 && formType == "CPAPPurchase" && (
              <div className="mt-3">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>HN</th>
                      <th>Fullname</th>
                      <th>Doctor</th>
                      <th>AHI</th>
                      <th>Min SpO2</th>
                      <th>Pressure</th>
                      <th>Latest Sleep Study</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patients.map((patient, index) => (
                      <tr key={patient.id || index}>
                        <td>{index + 1}</td>
                        <td>{patient.hn}</td>
                        <td>
                          {patient.firstnameTh} {patient.lastnameTh}
                        </td>
                        <td>{patient.doctor}</td>
                        <td>{patient.ahi}</td>
                        <td>{patient.min_spo2}</td>
                        <td>{patient.pressure}</td>
                        <td>{patient.latestSleepStudyDate || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button
                  className="btn btn-success"
                  onClick={() => handleExportAll("CPAPPurchase")}
                >
                  Export
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default MedicalCert;
